import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://6339289aa5bb71d260c060227f89b9a4@o4511902472798208.ingest.de.sentry.io/4512179972276304",
  debug: false,
  environment: "prod",
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 0.1,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});
import { init } from 'astro/virtual-modules/prefetch.js';init()